import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type KpiService from 'walden-fast/services/kpi';
import type PowerBiService from 'walden-fast/services/power-bi';
import type UserService from 'walden-fast/services/user';
import type {
  PowerBiReportInternalCode,
  PowerBiReport,
} from 'walden-fast/types/fast-backend/power-bi';
import { type Pages } from 'walden-fast/services/power-bi';
import { SERVICE_NAMES } from 'walden-fast/utils/constants/services';

interface TokenReportAndPages {
  pages: Pages[];
  report: PowerBiReport;
  token: string;
}

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type DashboardModel = Resolved<ReturnType<DashboardRoute['model']>>;

export default class DashboardRoute extends Route {
  @service('kpi') declare kpiService: KpiService;
  @service('power-bi') declare powerBiService: PowerBiService;
  @service('user') declare userService: UserService;

  async model() {
    const kpiCodes: PowerBiReportInternalCode[] = [
      'KPI1',
      'KPI2',
      'KPI3',
      'KPI4',
      'KPI5',
      'KPI6',
    ];

    const userCanAccessService = this.userService.canAccessService(
      SERVICE_NAMES.WALDEN_DASHBOARD,
    );

    const kpiPromises = kpiCodes.map((code) =>
      this.powerBiService
        .getTokenReportAndPages({
          reportInternalCode: code,
        })
        .catch((error) => {
          console.warn(`Failed to load report ${code}:`, error);
          return null;
        }),
    );

    const kpiResults = userCanAccessService
      ? await Promise.all(kpiPromises)
      : [];

    const validKpis = kpiResults.filter(
      (result): result is TokenReportAndPages => result !== null,
    );

    return {
      stats: userCanAccessService
        ? await this.kpiService.getStatsForPage('Dashboard')
        : [],
      kpis: validKpis.map((kpi) => ({
        page: kpi.pages[0],
        report: kpi.report,
        token: kpi.token,
      })),
      user: this.userService.user,
    };
  }
}
